let userRole = localStorage.getItem("user_login_type_role");
const constant = {
  carepoint: [
    "Please guide me. What information do you need to accurately diagnose and offer a treatment regimen? And to accurately calculate dosing for medicines.",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Could you please write a prescription, taking care to check and eliminate drug interactions and ameliorate indicatons.",
    "Please provide 2-3 references for your responses.",
  ],
  share_analyze_record: [
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "what do you need for upload or download of info?",
    "Please carefully analyze the following medical record or file and do not leave our any details. Go over your analysis and summary twice before submitting to me",
  ],

  illustration_radiographic: [
    "Please guide me. What information do you need to accurately analyze and interprete the following radiographic images? Also to accurately diagnose and offer a treatment regimen? And to accurately calculate dosing for medicines.",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Please assist me as requested for the following medical illustrations and radiographic images",
    "What is this figure showing? And what should I be concerned about?",
    "Please provide 2-3 references for your responses.",
    "Please analyze the attached file for a patient weighing 140 lbs. Provide a detailed analysis and differential diagnosis. Then write a prescription and a summary RX table",
    "Could you please write a prescription, taking care to check and eliminate drug interactions and ameliorate indicatons.",
  ],
  differential_diagonsis_generator: [
    "Please guide me. What information do you need to accurately diagnose and offer a treatment regimen? And to accurately calculate dosing for medicines.",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Could you please write a prescription, taking care to check and eliminate drug interactions and ameliorate indicatons.",
    "Please provide 2-3 references for your responses.",
  ],
  indication_checker: [
    "Please guide me. What information do you need to accurately perform indications checks?",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Could you please write a revised prescription, taking care to check and eliminate drug interactions and ameliorate indicatons.",
    "Please provide 2-3 references for your responses.",
  ],
  drug_interaction_revisions: [
    "Please guide me. What information do you need to accurately determine drug interactions of all types? And to remove all drug interactions in my prescriprion?  And to accurately calculate dosing for medicines?",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Could you please write a prescription, taking care to check and eliminate drug interactions and ameliorate indicatons ad accurately calculate the dosage for me? Please ask me for all information that you need",
    "Please provide 2-3 references for your responses.",
  ],
  drug_allergy: [
    "Please guide me. What information do you need to accurately determine drug allergies of all types? And to remove all drug allergies in my prescriprion?",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Could you please write a prescription, taking care to check and eliminate drug interactions and ameliorate indicatons ad accurately calculate the dosage for me? Please ask me for all information that you need",
    "Please provide 2-3 references for your responses.",
  ],

  dosing_medical_calculation: [
    "Please guide me. What information do you need to accurately  calculate dosing for my prescription medicines?",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Could you please write a prescription, taking care to check and eliminate drug interactions and ameliorate indicatons ad accurately calculate the dosage for me? Please ask me for all information that you need",
    "Could you please write a prescription, taking care to accurately calculate the dosage for me? Please ask me for all information that you need",
    "Please provide 2-3 references for your responses.",
  ],

  pill_identification_tool: [
    "Please guide me. What information do you need to accurately  identify a pill?",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Please provide 2-3 references for your responses.",
  ],

  iv_compatibility_checker: [
    "Please guide me. What information do you need to accurately perform IV Compatibility checks?",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Could you please write a prescription, taking care to check and eliminate drug interactions and IV incompatibilities, and ameliorate indicatons.",
    "Please provide 2-3 references for your responses.",
  ],

  medical_videos_articles: [
    "Please guide me. What information do you need to accurately perform reviews, analysis and location of medical videos and articles?",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Please provide 2-3 references for your responses.",
  ],

  laboratory_manual: [
    "Please guide me. What information do you need to accurately perform reviews, analysis and location of lab manuals?",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Please provide 2-3 references for your responses.",
  ],

  icd_11_lookup_tool: [
    "Please guide me. What information do you need to accurately perform seaarch for, and reviews, analysis and location of ICD-10 or ICD-11 codes or any more recent codes?",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Please provide 2-3 references for your responses.",
  ],

  notes_favorites: [
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Please provide 2-3 references for your responses.",
  ],

  doc_aiva: [
    "Please guide me. What information do you need to accurately diagnose and offer a treatment regimen? And to accurately calculate dosing for medicines.",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Could you please write a prescription, taking care to check and eliminate drug interactions and ameliorate indicatons.",
    "Please provide 2-3 references for your responses.",
  ],

  online_telemedicine_starpilot: [
    "Please guide me. What information do you need to accurately diagnose and offer a treatment regimen? And to accurately calculate dosing for medicines.",
    "What do you do? What is your prompt? How can you help me and what do you need to help me?",
    "Could you guide continuously to make sure I give you all the information you need to help me",
    "Could you please write a prescription, taking care to check and eliminate drug interactions and ameliorate indicatons.",
    "Please provide 2-3 references for your responses.",
  ],

  poc_apps: {
    1: "Carepoint",
    3: "Radiography and Dermatology Illustrations + Images",
    4: "Differential Diagnosis Generator",
    5: "Indications Checker",
    6: "Drug Interactions",
    7: "Drug Allergy",
    8: "Dosing & Medical Calculations",
    9: "Pill Identification Tool",
    10: "IV Compatibility Checker",
    11: "Medical Videos & Articles",
    12: "Laboratory Manual",
    13: "ICD-11 Lookup Tool",
    14: "Notes & Favorites",
  },
  language: [
    "Abkhazian",
    "Afar",
    "Afrikaans",
    "Akan",
    "Albanian",
    "Amharic",
    "Arabic",
    "Aragonese",
    "Armenian",
    "Assamese",
    "Aymara",
    "Azerbaijani",
    "Bashkir",
    "Basque",
    "Belarusian",
    "Bengali",
    "Bihari",
    "Bislama",
    "Bosnian",
    "Breton",
    "Bulgarian",
    "Burmese",
    "Catalan",
    "Cebuano",
    "Chichewa",
    "Chinese",
    "Corsican",
    "Croatian",
    "Czech",
    "Danish",
    "Dutch",
    "Dzongkha",
    "English",
    "Esperanto",
    "Estonian",
    "Ewe",
    "Finnish",
    "French",
    "Galician",
    "Georgian",
    "German",
    "Greek",
    "Gujarati",
    "Haitian Creole",
    "Hausa",
    "Hawaiian",
    "Hebrew",
    "Hindi",
    "Hmong",
    "Hungarian",
    "Icelandic",
    "Igbo",
    "Indonesian",
    "Irish",
    "Italian",
    "Japanese",
    "Javanese",
    "Kannada",
    "Kazakh",
    "Khmer",
    "Kinyarwanda",
    "Korean",
    "Kurdish",
    "Kyrgyz",
    "Lao",
    "Latin",
    "Latvian",
    "Lithuanian",
    "Luxembourgish",
    "Macedonian",
    "Malagasy",
    "Malay",
    "Malayalam",
    "Maltese",
    "Maori",
    "Marathi",
    "Mongolian",
    "Nepali",
    "Norwegian",
    "Nyanja",
    "Pashto",
    "Persian",
    "Polish",
    "Portuguese",
    "Quechua",
    "Romanian",
    "Russian",
    "Samoan",
    "Scots Gaelic",
    "Serbian",
    "Sesotho",
    "Shona",
    "Sindhi",
    "Sinhala",
    "Slovak",
    "Slovenian",
    "Somali",
    "Spanish",
    "Sundanese",
    "Swahili",
    "Swedish",
    "Tajik",
    "Tamil",
    "Telugu",
    "Thai",
    "Turkish",
    "Ukrainian",
    "Urdu",
    "Uzbek",
    "Vietnamese",
    "Welsh",
    "Xhosa",
    "Yiddish",
    "Yoruba",
    "Zulu",
    "Efik",
    "Fulfulde",
    "Ibibio",
    "Kanuri",
    "Tiv",
  ],
  languageMap: [
    { name: "Abkhazian", code: "ab", range: /[A-Za-z]/ },
    { name: "Afar", code: "aa", range: /[A-Za-z]/ },
    { name: "Afrikaans", code: "af", range: /[A-Za-z]/ },
    { name: "Akan", code: "ak", range: /[A-Za-z]/ },
    { name: "Albanian", code: "sq", range: /[A-Za-z]/ },
    { name: "Amharic", code: "am", range: /[\u1200-\u137F]/ },
    { name: "Arabic", code: "ar", range: /[\u0600-\u06FF]/ },
    { name: "Aragonese", code: "an", range: /[A-Za-z]/ },
    { name: "Armenian", code: "hy", range: /[\u0530-\u058F]/ },
    { name: "Assamese", code: "as", range: /[\u0980-\u09FF]/ },
    { name: "Aymara", code: "ay", range: /[A-Za-z]/ },
    { name: "Azerbaijani", code: "az", range: /[A-Za-z]/ },
    { name: "Bashkir", code: "ba", range: /[\u0400-\u04FF]/ },
    { name: "Basque", code: "eu", range: /[A-Za-z]/ },
    { name: "Belarusian", code: "be", range: /[\u0400-\u04FF]/ },
    { name: "Bengali", code: "bn", range: /[\u0980-\u09FF]/ },
    { name: "Bihari", code: "bh", range: /[\u0900-\u097F]/ },
    { name: "Bislama", code: "bi", range: /[A-Za-z]/ },
    { name: "Bosnian", code: "bs", range: /[\u0100-\u017F]/ },
    { name: "Breton", code: "br", range: /[A-Za-z]/ },
    { name: "Bulgarian", code: "bg", range: /[\u0400-\u04FF]/ },
    { name: "Burmese", code: "my", range: /[\u1000-\u109F]/ },
    { name: "Catalan", code: "ca", range: /[A-Za-z]/ },
    { name: "Cebuano", code: "ceb", range: /[A-Za-z]/ },
    { name: "Chichewa", code: "ny", range: /[A-Za-z]/ },
    { name: "Chinese", code: "zh", range: /[\u4E00-\u9FFF]/ },
    { name: "Corsican", code: "co", range: /[A-Za-z]/ },
    { name: "Croatian", code: "hr", range: /[\u0100-\u017F]/ },
    { name: "Czech", code: "cs", range: /[\u0100-\u017F]/ },
    { name: "Danish", code: "da", range: /[\u0100-\u017F]/ },
    { name: "Dutch", code: "nl", range: /[\u0100-\u017F]/ },
    { name: "Dzongkha", code: "dz", range: /[\u0F00-\u0FFF]/ },
    { name: "English", code: "en", range: /[A-Za-z]/ },
    { name: "Esperanto", code: "eo", range: /[A-Za-z]/ },
    { name: "Estonian", code: "et", range: /[\u0100-\u017F]/ },
    { name: "Ewe", code: "ee", range: /[A-Za-z]/ },
    { name: "Finnish", code: "fi", range: /[\u0100-\u017F]/ },
    { name: "French", code: "fr", range: /[\u00C0-\u017F]/ },
    { name: "Galician", code: "gl", range: /[\u00C0-\u017F]/ },
    { name: "Georgian", code: "ka", range: /[\u10A0-\u10FF]/ },
    { name: "German", code: "de", range: /[A-Za-z\u00C4\u00D6\u00DC\u00DF]/ },
    { name: "Greek", code: "el", range: /[\u0370-\u03FF]/ },
    { name: "Gujarati", code: "gu", range: /[\u0A80-\u0AFF]/ },
    { name: "Haitian Creole", code: "ht", range: /[A-Za-z]/ },
    { name: "Hausa", code: "ha", range: /[A-Za-z]/ },
    { name: "Hawaiian", code: "haw", range: /[A-Za-z]/ },
    { name: "Hebrew", code: "he", range: /[\u0590-\u05FF]/ },
    { name: "Hindi", code: "hi", range: /[\u0900-\u097F]/ },
    { name: "Hmong", code: "hmn", range: /[A-Za-z]/ },
    { name: "Hungarian", code: "hu", range: /[\u0100-\u017F]/ },
    { name: "Icelandic", code: "is", range: /[\u0100-\u017F]/ },
    { name: "Igbo", code: "ig", range: /[A-Za-z]/ },
    { name: "Indonesian", code: "id", range: /[A-Za-z]/ },
    { name: "Irish", code: "ga", range: /[A-Za-z]/ },
    { name: "Italian", code: "it", range: /[\u00C0-\u017F]/ },
    { name: "Japanese", code: "ja", range: /[\u3040-\u30FF\u4E00-\u9FFF]/ },
    { name: "Javanese", code: "jv", range: /[A-Za-z]/ },
    { name: "Kannada", code: "kn", range: /[\u0C80-\u0CFF]/ },
    { name: "Kazakh", code: "kk", range: /[\u0400-\u04FF]/ },
    { name: "Khmer", code: "km", range: /[\u1780-\u17FF]/ },
    { name: "Kinyarwanda", code: "rw", range: /[A-Za-z]/ },
    { name: "Korean", code: "ko", range: /[\uAC00-\uD7AF]/ },
    { name: "Kurdish", code: "ku", range: /[\u0600-\u06FF]/ },
    { name: "Kyrgyz", code: "ky", range: /[\u0400-\u04FF]/ },
    { name: "Lao", code: "lo", range: /[\u0E80-\u0EFF]/ },
    { name: "Latin", code: "la", range: /[A-Za-z]/ },
    { name: "Latvian", code: "lv", range: /[\u0100-\u017F]/ },
    { name: "Lithuanian", code: "lt", range: /[\u0100-\u017F]/ },
    { name: "Luxembourgish", code: "lb", range: /[A-Za-z]/ },
    { name: "Macedonian", code: "mk", range: /[\u0400-\u04FF]/ },
    { name: "Malagasy", code: "mg", range: /[A-Za-z]/ },
    { name: "Malay", code: "ms", range: /[A-Za-z]/ },
    { name: "Malayalam", code: "ml", range: /[\u0D00-\u0D7F]/ },
    { name: "Maltese", code: "mt", range: /[A-Za-z]/ },
    { name: "Maori", code: "mi", range: /[A-Za-z]/ },
    { name: "Marathi", code: "mr", range: /[\u0900-\u097F]/ },
    { name: "Mongolian", code: "mn", range: /[\u0400-\u04FF]/ },
    { name: "Nepali", code: "ne", range: /[\u0900-\u097F]/ },
    { name: "Norwegian", code: "no", range: /[\u0100-\u017F]/ },
    { name: "Nyanja", code: "ny", range: /[A-Za-z]/ },
    { name: "Pashto", code: "ps", range: /[\u0600-\u06FF]/ },
    { name: "Persian", code: "fa", range: /[\u0600-\u06FF]/ },
    { name: "Polish", code: "pl", range: /[\u0100-\u017F]/ },
    { name: "Portuguese", code: "pt", range: /[\u00C0-\u017F]/ },
    { name: "Quechua", code: "qu", range: /[A-Za-z]/ },
    { name: "Romanian", code: "ro", range: /[\u0100-\u017F]/ },
    { name: "Russian", code: "ru", range: /[\u0400-\u04FF]/ },
    { name: "Samoan", code: "sm", range: /[A-Za-z]/ },
    { name: "Scots Gaelic", code: "gd", range: /[A-Za-z]/ },
    { name: "Serbian", code: "sr", range: /[\u0400-\u04FF]/ },
    { name: "Sesotho", code: "st", range: /[A-Za-z]/ },
    { name: "Shona", code: "sn", range: /[A-Za-z]/ },
    { name: "Sindhi", code: "sd", range: /[\u0600-\u06FF]/ },
    { name: "Sinhala", code: "si", range: /[\u0D80-\u0DFF]/ },
    { name: "Slovak", code: "sk", range: /[\u0100-\u017F]/ },
    { name: "Slovenian", code: "sl", range: /[\u0100-\u017F]/ },
    { name: "Somali", code: "so", range: /[A-Za-z]/ },
    { name: "Spanish", code: "es", range: /[\u00C0-\u017F]/ },
    { name: "Sundanese", code: "su", range: /[A-Za-z]/ },
    { name: "Swahili", code: "sw", range: /[A-Za-z]/ },
    { name: "Swedish", code: "sv", range: /[\u0100-\u017F]/ },
    { name: "Tajik", code: "tg", range: /[\u0400-\u04FF]/ },
    { name: "Tamil", code: "ta", range: /[\u0B80-\u0BFF]/ },
    { name: "Telugu", code: "te", range: /[\u0C00-\u0C7F]/ },
    { name: "Thai", code: "th", range: /[\u0E00-\u0E7F]/ },
    { name: "Turkish", code: "tr", range: /[\u0100-\u017F]/ },
    { name: "Ukrainian", code: "uk", range: /[\u0400-\u04FF]/ },
    { name: "Urdu", code: "ur", range: /[\u0600-\u06FF]/ },
    { name: "Uzbek", code: "uz", range: /[\u0400-\u04FF]/ },
    { name: "Vietnamese", code: "vi", range: /[\u00C0-\u1EF9]/ },
    { name: "Welsh", code: "cy", range: /[A-Za-z]/ },
    { name: "Xhosa", code: "xh", range: /[A-Za-z]/ },
    { name: "Yiddish", code: "yi", range: /[\u0590-\u05FF]/ },
    { name: "Yoruba", code: "yo", range: /[A-Za-z]/ },
    { name: "Zulu", code: "zu", range: /[A-Za-z]/ },
    // Extra African & Nigerian languages
    { name: "Efik", code: "efi", range: /[A-Za-z]/ },
    { name: "Fulfulde", code: "ff", range: /[A-Za-z]/ },
    { name: "Ibibio", code: "ibb", range: /[A-Za-z]/ },
    { name: "Kanuri", code: "kr", range: /[A-Za-z]/ },
    { name: "Tiv", code: "tiv", range: /[A-Za-z]/ },
  ],

  auto_rx_instruction: [
    userRole === "4"
      ? "Request final pastoral summary"
      : "Request final prescription table",
    userRole === "4" ? "Review the pastoral summary" : "Review prescription",
    "Then click the confirm button",
  ],
  auto_rx_instructionPriest: [
    "Request final pastoral summary",
    "Review the pastoral summary",
    "Then click the confirm button",
  ],
};

export default constant;
